export class NICEDispClassification {
    classificationId: number;
    businessUnitId: number;
    classificationName: string;
    classificationTypeId: number;
    direction: number;
    dialingOutcomeId: number;
    reportingGroupId: number;
    description: string;
    showCommitmentAmount: boolean;
    showRescheduleDate: boolean;
    isAgentSpecific: boolean;
    isDestinationFinal: boolean;
    isContactFinal: boolean;
    excludeFromSerialDelivery: boolean;
    carryoverForCallback: boolean;

    constructor(niceClassification?) {
        if (niceClassification != null) {
            this.classificationId = niceClassification.classificationId || null;
            this.businessUnitId = niceClassification.businessUnitId || null;
            this.classificationName = niceClassification.classificationName || null;
            this.classificationTypeId = niceClassification.classificationTypeId || null;
            this.direction = niceClassification.direction || null;
            this.dialingOutcomeId = niceClassification.dialingOutcomeId || null;
            this.reportingGroupId = niceClassification.reportingGroupId || null;
            this.description = niceClassification.description || null;
            this.showCommitmentAmount = niceClassification.showCommitmentAmount || false;
            this.showRescheduleDate = niceClassification.showRescheduleDate || false;
            this.isAgentSpecific = niceClassification.isAgentSpecific || false;
            this.isDestinationFinal = niceClassification.isDestinationFinal || false;
            this.isContactFinal = niceClassification.isContactFinal || false;
            this.excludeFromSerialDelivery = niceClassification.excludeFromSerialDelivery || false;
            this.carryoverForCallback = niceClassification.carryoverForCallback || false;
        }
    }
}

